/**
 * @generated SignedSource<<597d47d67d8e128f6fbdebbcd5945901>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type headlineSection$data = {
  readonly name: string;
  readonly urlAlias: string;
  readonly " $fragmentType": "headlineSection";
};
export type headlineSection$key = {
  readonly " $data"?: headlineSection$data;
  readonly " $fragmentSpreads": FragmentRefs<"headlineSection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "headlineSection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlAlias",
      "storageKey": null
    }
  ],
  "type": "Section",
  "abstractKey": null
};

(node as any).hash = "f114456fbccaf8b1d274f3284b5391d9";

export default node;
